import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-password-reminder',
  standalone: false,
  templateUrl: './password-reminder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./password-reminder.component.scss']
})
export class PasswordReminderComponent {
  reminderForm: FormGroup;
  captchaQuestion: string = '';
  captchaAnswer: number = 0; // Replace with your real site key
  errorMessage: string = '';
  successMessage: string = '';

  constructor(private fb: FormBuilder, private usersService: UsersService, private snackBar: MatSnackBar) {
    this.reminderForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      captcha: ['', [Validators.required]],
    });
  }

  onSubmit() {
    this.errorMessage = '';
    this.successMessage = '';
    if (this.reminderForm.valid) {
      const { email, captcha } = this.reminderForm.value;
      if (parseInt(captcha, 10) !== this.captchaAnswer) {
        this.errorMessage = 'Niepoprawny wynik działania captcha.';
        this.generateCaptcha();
        this.reminderForm.patchValue({ captcha: '' });
        return;
      }
      const redirectUrl = window.location.origin + '/reset-hasla';
      this.usersService.remind(email, redirectUrl).subscribe({
        next: () => {
          this.successMessage = 'Instrukcje do resetowania hasła zostały wysłane na podany adres e-mail. Proszę sprawdzić swoją skrzynkę odbiorczą. Klikając w link w wiadomości, zostaniesz przekierowany do strony resetowania hasła.';
          this.reminderForm.reset();
          this.generateCaptcha();
        },
        error: (error) => {

          
          // Check if it's the "User not found" error
          if (error.status === 500 && 
              error.error && 
              error.error.detail === '404: User not found') {
            this.errorMessage = 'Podany adres e-mail nie istnieje w naszej bazie danych. Sprawdź poprawność adresu lub zarejestruj się.';
          } else if (error.status === 500) {
            this.errorMessage = 'Wystąpił błąd serwera. Spróbuj ponownie później.';
          } else if (error.status === 0) {
            this.errorMessage = 'Brak połączenia z serwerem. Sprawdź połączenie internetowe.';
          } else {
            this.errorMessage = `Nie udało się wysłać przypomnienia (kod błędu: ${error.status}). Spróbuj ponownie później.`;
          }

          // Display error message as toast
          this.snackBar.open(this.errorMessage, 'Zamknij', {
            duration: 12000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
          
          this.generateCaptcha();
        }
      });
    }
  }

  ngOnInit(): void {
    this.generateCaptcha();
  }


  generateCaptcha(): void {
    const num1 = Math.floor(Math.random() * 10) + 1; // Random number between 1 and 10
    const num2 = Math.floor(Math.random() * 10) + 1; // Random number between 1 and 10
    this.captchaQuestion = `Jaki jest wynik działania: ${num1} + ${num2}?`;
    this.captchaAnswer = num1 + num2;
  }
}